import { _ as _defineProperty } from '../defineProperty-Y-S4SptN.js';
import { _ as _objectWithoutProperties } from '../objectWithoutProperties-w3bsUgPa.js';
import classNames from 'classnames';
import { S as SvgIcon } from '../SvgIcon-zgkXaGhD.js';
import noop from '../noop/index.js';
import createUseStyles from '../create/index.js';
import { j as jsxRuntimeExports } from '../jsx-runtime-KJzvSKZ_.js';

var ImageHolderSize = /*#__PURE__*/function (ImageHolderSize) {
  ImageHolderSize["Large"] = "large";
  ImageHolderSize["Medium"] = "medium";
  ImageHolderSize["Small"] = "small";
  return ImageHolderSize;
}({});
var ImageHoldertype = /*#__PURE__*/function (ImageHoldertype) {
  ImageHoldertype["Collage"] = "collage";
  ImageHoldertype["Sticker"] = "sticker";
  return ImageHoldertype;
}({});

var layer = {
  content: "''",
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(225,225,225, 0.01)',
  backdropFilter: 'blur(0.7px)'
};
var useStyles = createUseStyles({
  root: {
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundSize: 'cover',
    borderRadius: 4,
    backgroundBlendMode: 'multiply',
    overflow: 'hidden',
    '&[data-type="contain"]': {
      '& img': {
        padding: function padding(props) {
          return props.imageUrl ? 8 : '';
        }
      }
    },
    '&:not([data-placeholder])': {
      backgroundColor: 'var(--backgrounds-tint-2)'
    },
    '&[data-placeholder]': {
      backgroundImage: 'conic-gradient(var(--backgrounds-tint-2) 90deg, var(--backgrounds-tint-4) 0 180deg, var(--backgrounds-tint-2) 0 270deg, var(--backgrounds-tint-4) 0)',
      backgroundSize: '10px 10px',
      position: 'relative',
      '&:after': {
        extend: function extend(props) {
          return !props.imageUrl && layer;
        }
      },
      '& img': {
        backdropFilter: function backdropFilter(props) {
          return props.imageUrl ? 'blur(0.7px)' : '';
        }
      }
    },
    '&[data-height-auto="true"]': {
      height: 'auto'
    },
    '&[data-width-auto="true"]': {
      width: 'auto'
    }
  },
  medium: {
    '&[data-height-auto="false"]': {
      height: 48
    },
    '&[data-width-auto="false"]': {
      width: 48
    }
  },
  small: {
    '&[data-height-auto="false"]': {
      height: 36
    },
    '&[data-width-auto="false"]': {
      width: 36
    }
  },
  large: {
    '&[data-height-auto="false"]': {
      height: 100
    },
    '&[data-width-auto="false"]': {
      width: 100
    }
  },
  image: {
    display: 'block',
    objectFit: 'cover',
    '&[data-type="contain"]': {
      objectFit: 'contain'
    },
    '&[data-width-auto="false"]': {
      width: '100%'
    },
    '&[data-height-auto="false"]': {
      height: '100%'
    },
    '&[data-is-shutterstock="true"]': {
      height: 'calc(100% + 10px)'
    }
  },
  icon: {
    position: 'relative',
    top: '50%',
    left: '50%',
    display: 'inline-block',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none'
  }
});

var _excluded = ["size", "imageUrl", "imageAlt", "type", "autoHeight", "autoWidth", "className", "width", "height", "onClick", "background", "isShutterStock", "enablePlaceholder", "iconName", "iconSize", "iconHeight", "iconWidth", "minHeight", "imageClassName", "loading", "isDragDisabled", "onLoad", "onError"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ImageHolder(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? ImageHolderSize.Large : _ref$size,
    _ref$imageUrl = _ref.imageUrl,
    imageUrl = _ref$imageUrl === void 0 ? '' : _ref$imageUrl,
    _ref$imageAlt = _ref.imageAlt,
    imageAlt = _ref$imageAlt === void 0 ? '' : _ref$imageAlt,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? ImageHoldertype.Collage : _ref$type,
    _ref$autoHeight = _ref.autoHeight,
    autoHeight = _ref$autoHeight === void 0 ? false : _ref$autoHeight,
    _ref$autoWidth = _ref.autoWidth,
    autoWidth = _ref$autoWidth === void 0 ? false : _ref$autoWidth,
    className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    background = _ref.background,
    isShutterStock = _ref.isShutterStock,
    enablePlaceholder = _ref.enablePlaceholder,
    iconName = _ref.iconName,
    iconSize = _ref.iconSize,
    iconHeight = _ref.iconHeight,
    iconWidth = _ref.iconWidth,
    minHeight = _ref.minHeight,
    imageClassName = _ref.imageClassName,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? 'eager' : _ref$loading,
    isDragDisabled = _ref.isDragDisabled,
    _ref$onLoad = _ref.onLoad,
    onLoad = _ref$onLoad === void 0 ? function () {} : _ref$onLoad,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function () {} : _ref$onError,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles({
    imageUrl: imageUrl
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    jsxRuntimeExports.jsxs("div", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, enablePlaceholder && {
      'data-placeholder': enablePlaceholder
    }), (type === ImageHoldertype.Sticker || iconName) && {
      'data-type': 'contain'
    }), {}, {
      "data-height-auto": autoHeight,
      "data-width-auto": autoWidth,
      className: classNames(classes.root, classes[size], className),
      onClick: onClick,
      role: "button",
      style: _objectSpread({
        minHeight: minHeight,
        backgroundColor: background,
        height: height,
        width: width
      }, props.style)
    }, props), {}, {
      children: [iconName && /*#__PURE__*/jsxRuntimeExports.jsx(SvgIcon, {
        name: iconName,
        className: classes.icon,
        style: {
          width: iconSize || iconWidth || 32,
          height: iconSize || iconHeight || 32
        }
      }), imageUrl && /*#__PURE__*/jsxRuntimeExports.jsx("img", _objectSpread(_objectSpread({
        onLoad: onLoad,
        loading: loading,
        onError: onError,
        className: classNames(classes.image, imageClassName),
        src: imageUrl,
        alt: imageAlt
      }, type === ImageHoldertype.Sticker && {
        'data-type': 'contain'
      }), {}, {
        "data-width-auto": autoWidth,
        "data-height-auto": autoHeight,
        "data-is-shutterstock": isShutterStock
      }, isDragDisabled && {
        draggable: 'false'
      }))]
    }))
  );
}

export { ImageHolderSize, ImageHoldertype, ImageHolder as default };
//# sourceMappingURL=index.js.map
